import {useAuthUserStore} from "@/stores/auth";

export default {
    index(params) {
        return useAuthUserStore().getApiClient.get('/reports/orders', {
            params: params
        })
    },
    download(params) {
        return useAuthUserStore().getApiClient.get('/export/orders', {
            responseType: 'blob',
            params: params
        })
    }
}